import { AngularSQLFactory } from './angular-sql-query.factory';

export default angular
  .module('sfMobile.services.angular-sql-query', [])
  .factory('angularSQLFactory', AngularSQLFactory).name;
